import { createAction } from 'redux-actions';

export const setAuthUser = createAction('SET_AUTH_USER');